import { render, staticRenderFns } from "./CnCoaDetail.vue?vue&type=template&id=3cdcebbe&scoped=true&"
import script from "./CnCoaDetail.vue?vue&type=script&lang=js&"
export * from "./CnCoaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CnCoaDetail.vue?vue&type=style&index=0&id=3cdcebbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcebbe",
  null
  
)

export default component.exports